export const UNSUPPORTED_INPUT_PROPS = ["tReady"];
